export const SESSION_STORAGE_KEYS = {
  IMPERSONATION_USER: 'impersonationUser',
  EMBEDDED_API_ACCESS_TOKEN: 'embeddedApiAccessToken',
};
